export default "__VITE_ASSET__TKA_0M$M__"